import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { IMAGE_CONFIG, isPlatformBrowser } from '@angular/common';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';


export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), 
              provideClientHydration(), provideAnimations(), provideHttpClient(withFetch()),
              importProvidersFrom(BrowserAnimationsModule), { provide: IMAGE_CONFIG, useValue: 
              { disableImageSizeWarning: true, disableImageLazyLoadWarning: true } },
              importProvidersFrom(RecaptchaV3Module),
              {
                provide: RECAPTCHA_V3_SITE_KEY,
                useValue: "6LdQg7srAAAAAPFPwzL-pTUzz7Ezr7jTQwO3UR5t"
              }]
};